// Converted from application/views/exhibition_v.php. Edit this component directly.
export default function ExhibitionPage() {
  return <><div class={"firstContainer container photoLeft"}>
<div class={"photo"}>
<img src={"/assets/images/exhibitions/sweet-noise-of-life-pietrasanta/IMG-20180130-WA0002.jpg"} alt={""} />
</div>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Pietrasanta"}</h1>
<h3>{"February 2018"}</h3>
<h2>{"\n                    Lorem Ispum is simply dummy text\n                "}</h2>
</div>
<p>{"\n                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n            "}</p>
<p>{"\n                It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\n            "}</p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<div class={"photo"}>
<img src={"/assets/images/exhibitions/sweet-noise-of-life-pietrasanta/mother-and-child.jpg"} alt={""} />
</div>
<div class={"text"}>
<p>{"\n            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.\n        "}</p>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h2>{"\n                    Lorem Ispum is simply dummy text\n                "}</h2>
</div>
<p>{"\n                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\n            "}</p>
</div>
</div>
<div class={"photo"}>
<img src={"/assets/images/exhibitions/sweet-noise-of-life-pietrasanta/Life and Death.jpg"} alt={""} />
</div>
</div>
</>;
}
